import React, { createContext, useState, useEffect } from "react"
import API from "../../../api/api"
import testJobOrderData from "../../../test/jobOrderList.json"
import jobTableTitle from "../../../constants/JobTableTitle.json"
import orderDetailsTestFile from "../../../test/orderDetails.json"
import { db } from "../../../helpers/firebase_helper"

export const DetailsContext = createContext()

/**
 * This is the provider that is used to wrap the Order list container to access the context in OrderList.jsx
 * @param {Object} children
 * @returns {Object}
 */
export const DetailsContextProvider = ({ children }) => {
  const [serviceDetails, setServiceDetails] = useState([""])
  const [userDetails, setUserDetails] = useState([""])
  const [particularList, setParticularList] = useState([])
  const [currentPartnerType, setCurrentPartnerType] = useState([])
  const [orderListOfSelectedUser, setOrderListOfSelectedUser] = useState()


  // const getUserDetails

  // const getServiceDetails = serviceId => {
  //   console.log("admin id", adminId)
  //   try {
  //     API.getAdminDetails(adminId).then(response => {
  //       console.log("responseeee", response.data.data)
  //       setAdminDetails(response.data.data)
  //     })
  //   } catch (e) {}
  // }

  const getAdminDetails = adminId => {
    // console.log("admin id", adminId)
    try {
      //   API.getAdminDetails(adminId).then(response => {
      //     console.log("responseeee", response.data.data)
      //     setAdminDetails(response.data.data)
      //   })
    } catch (e) {}
  }

  /**
   * ********************************************************************
   *
   * FIREBASE INTEGRATION
   *
   * **********************************************************************
   */

  const getServiceDetails = async serviceId => {
    let serviceList = []
    const snapshot = await db.collection("services").doc(serviceId).get()
    getParticulars(serviceId)
    getPartnerTypes(serviceId)
    // await snapshot.forEach(async doc => {
    //   const snapshotDashboard = await db
    //     .collection("services")
    //     .doc(doc.id)
    //     .get()

    //   const userDoc = { ...snapshotDashboard.data(), id: doc.id }
    //   console.log("_________Each for each result_______", userDoc)
    //   serviceList.push(userDoc)
    //   dispatch({ type: SERVICE_LIST, payload: serviceList })
    //   setAdminData(serviceList)
    // })
    console.log("details page", snapshot.data())
    setServiceDetails(snapshot.data())
  }

  const getParticulars = async serviceId => {
    let particular = []
    const snapshot = await db
      .collection("services")
      .doc(serviceId)
      .collection("particulars")
      .get()
    snapshot.forEach((doc, index) => {
      particular.push({ id: doc.id, ...doc.data() })
    })
    setParticularList(particular)
  }

  const getPartnerTypes = async serviceId => {
    let partnerTypes = []
    const snapshot = await db
      .collection("services")
      .doc(serviceId)
      .collection("partnerTypes")
      .get()
    await snapshot.forEach(async (doc, index) => {
      partnerTypes.push({ id: doc.id, ...doc.data() })
    })
    setCurrentPartnerType(partnerTypes)
  }

  const getUserDetails = async userId => {
    let userAddresses = []
    const snapshot = await db.collection("users").doc(userId).get()
    const userAddressSnapshot = await db
      .collection("users")
      .doc(userId)
      .collection("addresses")
      .get()
    await userAddressSnapshot.forEach(async (doc, index) => {
      userAddresses.push(doc.data())
    })
    setUserDetails({ ...snapshot.data(), userAddresses })

    // const snapshot = await db.collection("orders").doc(userId).get()
  }

  const providerValue = {
    userDetails,
    serviceDetails,
    particularList,
    currentPartnerType,
    getParticulars,
    getPartnerTypes,
    getUserDetails,
    getServiceDetails,
    getAdminDetails,
  }

  return (
    <DetailsContext.Provider value={providerValue}>
      {children}
    </DetailsContext.Provider>
  )
}

//TODO: REPLACE THE STATIC DATA PROVIDED TO ORDER DATA WHEN API ISSUE IS FIXED
